import { type PairingDetail } from '@hungryroot/rest';
import { formatNutritionValue, stringNumberToNumberNoDecimal } from '../main';

export const generateNutritionProductInfoConfig = (
  nutrition: PairingDetail['nutrition'] | undefined
) => {
  return [
    {
      label: 'Calories',
      value: `${
        nutrition
          ? stringNumberToNumberNoDecimal(nutrition.calories.toString())
          : ''
      }`,
    },
    {
      label: 'Fat',
      value: `${
        nutrition ? formatNutritionValue(nutrition.total_fat, 'total_fat') : ''
      }`,
    },
    {
      label: 'Carbs',
      value: `${
        nutrition
          ? formatNutritionValue(nutrition.total_carb, 'total_carb')
          : ''
      }`,
    },
    {
      label: 'Protein',
      value: `${
        nutrition ? formatNutritionValue(nutrition.protein, 'protein') : ''
      }`,
    },
    {
      label: 'Sugars',
      value: `${
        nutrition ? formatNutritionValue(nutrition.sugars, 'sugars') : ''
      }`,
    },
  ];
};

export const nutritionDisclaimer =
  'The % Daily Value (DV) is based on a 2,000 calorie diet. Calorie amount includes all olive oil mentioned in the recipe.';

export const generateRDPModalProductInfoConfig = ({
  cookingTime,
  numRatings,
  nutrition,
  recipeScore,
  servings,
}: {
  cookingTime: number;
  numRatings: number | undefined;
  nutrition: PairingDetail['nutrition'] | undefined;
  recipeScore: number | undefined;
  servings: number | undefined;
}) => {
  return [
    {
      label: 'Rating',
      value: recipeScore
        ? `${stringNumberToNumberNoDecimal(
            recipeScore.toString()
          )}% (${numRatings})`
        : 'New',
    },
    {
      label: 'Cook time',
      value: `${cookingTime} min`,
    },
    {
      label: 'Serving',
      value: `${servings}`,
    },
    {
      label: 'Cal per serv.',
      value: `${nutrition ? nutrition.calories : ''}`,
    },
  ];
};
